import {AUTH_ERROR, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS} from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
// import apiCall from '@/utils/api.js'
import { mock } from '../../utils/mockdata';

var axios = require('axios');

export default {

  state: {
    token: localStorage.getItem('user-token') || '',
    status: '',
    hasLoadedOnce: false
  },
  mutations: {
    [AUTH_REQUEST]: (state) =>  {
      state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, resp) => {
      state.status = 'success'
      state.token = resp.token
      state.hasLoadedOnce = true
    },
    [AUTH_ERROR]: (state) => {
      state.status = 'error'
      state.hasLoadedOnce = true
    },
    [AUTH_LOGOUT]: (state) => {
      state.token = ''
    }

  },
  actions: {
    [AUTH_REQUEST]: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST)
        // apiCall({url: 'auth', data: user, method: 'POST'})
        //   .then(resp => {
        //     localStorage.setItem('user-token', resp.token)
        //     // Here set the header of your ajax library to the token value.
        //     // example with axios
        //     // axios.defaults.headers.common['Authorization'] = resp.token
        //     commit(AUTH_SUCCESS, resp)
        //     dispatch(USER_REQUEST)
        //     resolve(resp)
        //   })
        //   .catch(err => {
        //     commit(AUTH_ERROR, err)
        //     localStorage.removeItem('user-token')
        //     reject(err)
        //   })

        // ====
        var formData = new FormData()
        formData.append('username', user.username)
        formData.append('password', user.password)

        mock.onPost('/v1/login', formData).reply(
          200, {token: 'This-is-a-mocked-token'}
        );

        // this.userauthkey = "" //..delete actual key (if any)

        axios.post('/v1/login', formData)
        .then(response => {

            var userauthkey = response.data.token
            // var respdata = response.data
            // console.log("got > "+JSOn.stringify(respdata))
            // console.log("test > "+ (respdata == "ok"))
            // valid = (respdata.status=="ok") ? true : false;
            // this.userauthkey = (respdata.status=="ok") ? respdata.userauthkey : "---";
            // console.log('got from server> '+JSON.stringify(respdata));
            // if (!valid) alert("Login failed!").then(() => {console.log("Dialog closed")})


            localStorage.setItem('user-token', userauthkey)
            // Here set the header of your ajax library to the token value.
            // example with axios
            // axios.defaults.headers.common['Authorization'] = resp.token
            commit(AUTH_SUCCESS, response.data)
            dispatch(USER_REQUEST)
            resolve(response.data)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
          



      })
    },
    [AUTH_LOGOUT]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_LOGOUT)
        localStorage.removeItem('user-token')
        resolve()
      })
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
  }

}

// == Default structure ==
// export default {
//   state: {},
//   mutations: {},
//   actions: {},
//   getters: {}
